import { Fragment } from "react";
import { BOOK_TAGLINE } from "@/content";

// Renders the tagline so line breaks only ever fall between full
// sentences — never leaving a single word stranded on its own line.
const BookTagline = () => {
  const sentences = BOOK_TAGLINE.split(". ").map((s) => (s.endsWith(".") ? s : `${s}.`));
  return (
    <>
      {sentences.map((s, i) => (
        <Fragment key={i}>
          <span className="whitespace-nowrap">{s}</span>
          {i < sentences.length - 1 ? " " : ""}
        </Fragment>
      ))}
    </>
  );
};

export default BookTagline;
